export const DEFAULT_OVERLAYS = {
  labels: true,
  user: false,
};
